import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { openWebinar } from "@/data/content";

export const StickyMobileCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-[99] p-3 md:hidden"
        >
          <div className="glass rounded-2xl border border-white/10 p-2">
            <button
              type="button"
              onClick={openWebinar}
              data-testid="sticky-mobile-cta"
              className="flex w-full items-center justify-center gap-2 rounded-xl bg-brand-green py-3.5 font-heading text-base font-bold uppercase tracking-wide text-brand-bg glow-green-sm"
            >
              Kostenlos anmelden
              <ArrowRight className="h-5 w-5" strokeWidth={2.5} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
